module.exports = __webpack_public_path__ + "img/logos_eu.a6a04982.png";